<template>
    <!--<div class="max-w-7xl mx-auto sm:px-6 lg:px-8">-->
    <div class="px-8 mb-8 bg-gray-50">
        <slot></slot>
    </div>
</template>